import React from 'react';
import request from "superagent";
import ReactDOM from "react-dom";
import CalendarForm from "./calendar_form";

const context = eventCalendarContext;


window.calendarState = {
  'form': {
    // values
    'containerClass': context.formClass,
    'onSelectFieldChange': handleSelectFieldChange,
    'onSingleCheckboxFieldChange': handleSingleCheckboxChange,
    'choices': {
      'dateRanges': context.dateRanges,
      'eventCategories': context.eventCategories,
    },
    'data': {
      // default values
      'dateRange': context.dateRange,
      'eventCategory': context.eventCategory
    }
  },
  'listing': {
    'class': context.listingClass,
    'isLoading': true
  }
};


// START
$(() => {
  renderAll();
});


function renderAll() {
  renderForm();
  refreshEvents();
}


function refreshEvents() {
  /* Show the events corresponding to the current form */
  calendarState.listing.isLoading = true;

  request
    .post(`/calendar-api/events/`)
    .type('form')
    .send({
      'csrfmiddlewaretoken': context.csrfToken,
      'date_range': calendarState.form.data.dateRange,
      'event_category': calendarState.form.data.eventCategory
    })
    .then(result => {
      if (result.body.success) {
        $(`.${calendarState.listing.class}`).html(result.body.html);
        calendarState.listing.isLoading = false;
      }
      else {
        console.log("Incorrect search");
        calendarState.listing.isLoading = false;
      }
    })
    .catch(err => {
      console.log(err.message, []);
      calendarState.listing.isLoading = false;
    });
}


function renderForm() {
  const mount_point = document.getElementsByClassName(calendarState.form.containerClass)[0];
  mount_form_component(mount_point);
}


function mount_form_component(mount_point) {
  ReactDOM.render(
    <CalendarForm calendarState={calendarState} />,
    mount_point
  );
}


function handleSelectFieldChange(form, fieldName, event) {
  form.data[fieldName] = event.target.value;
  updateUrlBasedOnSelection();
  renderAll();
}


function handleSingleCheckboxChange(form, fieldName, e) {
  // for a boolean field
  form.data[fieldName] = e.target.checked;
  form.hasChanged = true;
  updateUrlBasedOnSelection();
  renderAll();
}


function updateUrlBasedOnSelection() {
  let queryString = Object.keys(calendarState.form.data).reduce(function(result, key) {
    if (calendarState.form.data[key] || calendarState.form.data[key] === false) {
      if (result) {
        result += '&';
      }
      result += key + '=' + calendarState.form.data[key];
    }
    return result;
  }, '');

  let url = window.location.pathname + '?' + queryString;
  window.history.replaceState(null, null, url);
}
